export default function passwordToggle() {
    $('.password-visibility').click((e) => {
        const $el = $(e.target);
        const input = $el.closest('.input-group').find('input');
        const passwordVisible = $el.hasClass('password-visible');

        if (passwordVisible) {
            $el.removeClass('password-visible');
            input.attr('type', 'password');
        } else {
            $el.addClass('password-visible');
            input.attr('type', 'text');
        }
    });
}